import {
  Package, Smartphone, Shirt, Hammer, Wrench, Sparkles, Tv, Box, Wheat,
} from "lucide-react";

export const CAT_ICON = {
  food: Package,
  electronics: Smartphone,
  textiles: Shirt,
  construction: Hammer,
  auto_parts: Wrench,
  cosmetics: Sparkles,
  appliances: Tv,
  cleaning: Box,
  agriculture: Wheat,
};

export const CAT_COLOR = {
  food: "#B45309",
  electronics: "#1D4ED8",
  textiles: "#9D174D",
  construction: "#78350F",
  auto_parts: "#334155",
  cosmetics: "#A21CAF",
  appliances: "#0E7490",
  cleaning: "#0F766E",
  agriculture: "#3F6212",
};

export function catColor(id) {
  return CAT_COLOR[id] || "#334155";
}

export function fmt(n) {
  return Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function startPrice(p) {
  return p.tiers && p.tiers.length ? p.tiers[0].price : 0;
}

export function tierFor(p, q) {
  return (p.tiers || []).find((t) => q >= t.min && (t.max === null || q <= t.max)) || p.tiers[p.tiers.length - 1];
}

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function imgUrl(image) {
  if (!image) return null;
  return image.startsWith("http") ? image : `${BACKEND}${image}`;
}
